import client from "./client";

export const lookupsApi = {
  list: (category) => client.get(`/lookups/${category}`),

  // Machine types — full CRUD
  adminListMachineTypes: ()         => client.get("/admin/machine_types"),
  createMachineType:     (data)     => client.post("/admin/machine_types", data),
  updateMachineType:     (id, data) => client.patch(`/admin/machine_types/${id}`, data),
  removeMachineType:     (id)       => client.delete(`/admin/machine_types/${id}`),

  // MECO types — color-only edit
  adminListMecoTypes: ()         => client.get("/admin/meco_types"),
  updateMecoType:     (id, data) => client.patch(`/admin/meco_types/${id}`, data),
};
